import {
  isMobileOnly,
  isTablet,
  isIPad13
} from 'react-device-detect'

export const getContentSectionHeight = () => {
  // Dynamically retrieving visible height of search bar
  let searchBar = document.querySelector(".search-bar")
  let box = searchBar.getBoundingClientRect()
  let height = box.height - Math.abs(box.top)
  let defaultHeight = 60

  if(searchBar.classList.contains("show-extra-fields")) {
    defaultHeight = 135
  }

  let contentHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  ) - (height || defaultHeight)

  return `${contentHeight}px`
}

export const getContentSectionHeightMobile = () => {
  let contentHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  ) - 110

  // 160
  return `${contentHeight}px`
}

export const calcSearchHeight = (viewport) => {
  let tops = {"mobile": 62, "tablet": 80, "desktop": 80},
      breakpoints = {"mobile": 756, "tablet": 1024},
      contentHeight = "100%",
      header = 50,
      winHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )

  if(viewport.classList.contains("show-extra-fields")) {
    tops.desktop = 135
  }

  if (isMobileOnly || window.innerWidth <= breakpoints.mobile) {
    contentHeight = winHeight - tops.mobile - header
  } else if (isTablet || isIPad13 || window.innerWidth <= breakpoints.tablet) {
    contentHeight = winHeight - tops.tablet - header
  } else {
    // Desktop
    contentHeight = winHeight - tops.desktop
  }
  return contentHeight
}

// Responsively setting search viewport
export const getViewportSearchHeight = () => {
  let searchViewport = document.querySelector(".viewport.search")
  if(searchViewport) {
    let contentHeight = calcSearchHeight(searchViewport)
    searchViewport.style.height = `${contentHeight}px`
  }
}

// set height 100% - header height of 50px
export const setMainDashboardHeight = () => {
  let dashboard = document.querySelector("main.dashboard")
  if (dashboard) {
    let winHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    )
    dashboard.style.height = `${winHeight - 50}px`
  }
}

// check that the current height matchs
// what the calculations should be
export const responsiveHeightsCheck = () => {
  let dashboard      = document.querySelector("main.dashboard")
  let searchViewport = document.querySelector(".viewport.search")

  if(!dashboard || !searchViewport) return

  let winHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  )
  let dashboardCheck = dashboard.style.height === `${winHeight - 50}px`
  let searchHeight   = calcSearchHeight(searchViewport)
  let searchCheck    = searchViewport.style.height === (searchHeight + 'px')

  if(!dashboardCheck || !searchCheck) {
    // set new heights
    dashboard.style.height = `${winHeight - 50}px`
    searchViewport.style.height = `${searchHeight}px`
  }
}
